import Parse from "parse";

export const getImagesFromParcelId = async (data) => {
    const response = await Parse.Cloud.run("getImagesFromParcelId",data)
    return response
}